import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';

interface CustomizeTabsActionsProps {
  onCancel: () => void;
  loading: boolean;
}

export function CustomizeTabsActions({
  onCancel,
  loading,
}: CustomizeTabsActionsProps) {
  const { t } = useTranslation();

  const actions = [
    <Button
      key="cancel"
      buttonType={ButtonTypes.secondaryOutlined}
      buttonText={t('cancel')}
      leftIcon="close"
      onClick={onCancel}
      fullWidth
      disabled={loading}
    />,
    <Button
      key="save"
      type="submit"
      buttonType={ButtonTypes.primaryFilled}
      buttonText={t('save-changes')}
      leftIcon="check"
      fullWidth
      disabled={loading}
    />,
  ];

  return <ActionsRow actions={actions} />;
}
